import { Directive, ElementRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[timeParse][ngModel]',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { '(ngModelChange)': 'parseTime($event)' }
})
export class TimeParseDirective {

  public regexPatterns = {
    isDigit: { pattern: new RegExp(`[0-2]`) },
    hours: { pattern: new RegExp(`^([0-1]?[0-9]|2[0-3]):?$`) },
    hoursAndMinutes: { pattern: new RegExp(`^([0-1]?[0-9]|2[0-3]):[0-5][0-9]?$`) },
    hoursAndMinutesCompleted: { pattern: new RegExp(`^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$`) }
  };

  previousValue = '';

  constructor(
    public el: ElementRef) { }

  syncValue(value: string) {
    this.previousValue = value;
  }

  valueIsValid(): boolean {
    return this.regexPatterns.hoursAndMinutesCompleted.pattern.test(this.el.nativeElement.value);
  }

  parseTime(event) {
    if (event.length < this.previousValue.length) {
      if (this.previousValue[this.previousValue.length - 1] === ':') {
        this.setValue(this.previousValue.slice(0, this.previousValue.length - 2));
      } else {
        this.setValue(this.previousValue.slice(0, this.previousValue.length - 1));
      }
    } else if (event.length === 1 && this.regexPatterns.isDigit.pattern.test(event)) {
      this.setValue(event);
    } else if (event.length === 2 && this.regexPatterns.hours.pattern.test(event)) {
      this.setValue(`${event}:`);
    } else if (event.length > 3 && this.regexPatterns.hoursAndMinutes.pattern.test(event)) {
      this.setValue(event);
    } else {
      this.el.nativeElement.value = this.previousValue;
    }
  }

  private setValue(event: string) {
    this.el.nativeElement.value = event;
    this.previousValue = this.el.nativeElement.value;
  }
}
